export function formatIndianCurrency(value) {
    if (Number.isNaN(value)) return value;

    return new Intl.NumberFormat('en-IN', {
        maximumFractionDigits: 2
    }).format(value);
}